import { useMemo } from "react"
import { Svg, Rect } from "@react-pdf/renderer"
import JsBarcode from "jsbarcode"

/** @returns {string | null} Module pattern from JsBarcode ("1" = bar, "0" = gap). */
function getMasterBarcodeModules(value) {
    const text = String(value ?? "").trim()
    if (!text) {
        return null
    }

    try {
        const data = {}
        JsBarcode(data, text, {
            format: "CODE128",
            displayValue: false,
            margin: 0,
        })
        return data.encodings?.[0]?.data ?? null
    } catch (error) {
        console.error("BoxLabelBarcode encoding failed:", error)
        return null
    }
}

/**
 * CODE128 barcode for the master number — vector bars for crisp PDF output.
 *
 * @param {{
 *   value: string,
 *   width: number,
 *   height: number,
 * }} props Dimensions in PDF points.
 */
export default function BoxLabelBarcode({ value, width, height }) {
    const bars = useMemo(() => {
        const modules = getMasterBarcodeModules(value)
        if (!modules) {
            return []
        }

        const moduleWidth = width / modules.length
        const rects = []
        let x = 0

        for (let i = 0; i < modules.length; i++) {
            if (modules[i] === "1") {
                rects.push({ x, width: moduleWidth })
            }
            x += moduleWidth
        }

        return rects
    }, [value, width])

    if (bars.length === 0) {
        return null
    }

    return (
        <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            {bars.map((bar, index) => (
                <Rect
                    key={index}
                    x={bar.x}
                    y={0}
                    width={bar.width}
                    height={height}
                    fill="#000000"
                />
            ))}
        </Svg>
    )
}
